import React from 'react';
import styled from 'styled-components';
import { TextField, Box } from '@material-ui/core';

import { MultiAttributeTemplate, TableAttributeTemplate, CardTemplateAttributeDb } from '../redux/cardTemplateAttributeDbSlice';
import { CardTemplateShapeDb } from '../redux/cardTemplateShapeDbSlice';
import { MultiAttribute, TableAttribute, CardAttributeDb } from '../redux/cardAttributeDbSlice';
import { CardShapeDb } from '../redux/cardShapeDbSlice';
import { UiCardItemDb } from '../redux/uiCardItemDbSlice';
import { deepCopy } from '../general';

const NumberField = styled(TextField)`
  width: 40%;
  margin-right: 3px;
`

const isMulti = (obj: any): obj is MultiAttributeTemplate | MultiAttribute => {
  return obj?.cardAttributeModel === 'multi';
}
const isTable = (obj: any): obj is TableAttributeTemplate | TableAttribute => {
  return obj?.cardAttributeModel === 'table';
}
const isUiCardItem = (obj: any): obj is UiCardItemDb => {
  return typeof obj.type === 'string';
}

type EditItemPositionProps = {
  item: CardTemplateAttributeDb | CardTemplateShapeDb | CardAttributeDb | CardShapeDb | UiCardItemDb;
  changeItem: (item: any) => void;
}
const EditItemPosition: React.FC<EditItemPositionProps> = ({item, changeItem}) => {
  const positionUpdate = (key: string, value: number, min?: number, max?: number) => {
    let newValue = value;
    if (typeof min === 'number' && newValue < min) newValue = min;
    else if (typeof max === 'number' && newValue > max) newValue = max;
    const newItem = deepCopy(item);
    switch (key) {
      case 'x': newItem.x = newValue; break;
      case 'y': newItem.y = newValue; break;
      case 'w': newItem.width = newValue; break;
      case 'h': newItem.height = newValue; break;
      case 'r':
        if (!isUiCardItem(newItem)) newItem.rotation = newValue;
        break;
    }
    changeItem(newItem);
  }

  return (
    <Box>
      位置
      <Box mt={1}>
        <NumberField variant='outlined' label='X'
          type="number" inputProps={{step: 1}}
          value={item.x}
          onChange={(ev) => positionUpdate('x', Number(ev.target.value))}
        /> 
        <NumberField variant='outlined' label='Y'
          type="number" inputProps={{step: 1}}
          value={item.y} 
          onChange={(ev) => positionUpdate('y', Number(ev.target.value))}
        /> 
      </Box>
      <Box mt={1}>
        <NumberField variant='outlined' label='幅'
          type="number" inputProps={{step: 1}}
          value={item.width} 
          onChange={(ev) => positionUpdate('w', Number(ev.target.value))}
        /> 
        <NumberField variant='outlined' label='高さ'
          type="number" inputProps={{step: 1}}
          value={item.height} 
          onChange={(ev) => positionUpdate('h', Number(ev.target.value))}
        />
      </Box>
      { (!isMulti(item) && !isTable(item) && !isUiCardItem(item)) &&
        <Box mt={1}>
          <NumberField variant='outlined' label='回転（度）'
            type="number" inputProps={{min: -360, max: 360, step: 1}}
            value={item.rotation} 
            onChange={(ev) => positionUpdate('r', Number(ev.target.value), -360, 360)}
          /> 
        </Box> 
      }
    </Box>
  );
}

export default EditItemPosition;
